var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64748B",
    fillRule: "evenodd",
    d: "M16.072 7.336c-.036-.003-.077-.003-.12-.003H14.27c-1.379 0-2.558 1.085-2.558 2.5s1.18 2.5 2.558 2.5h1.683c.043 0 .084 0 .122-.003a1.17 1.17 0 0 0 1.096-1.085c.003-.04.003-.083.003-.123V8.544c0-.04 0-.083-.003-.123a1.17 1.17 0 0 0-1.096-1.085h-.002ZM14.12 10.5a.655.655 0 0 0 .642-.667.655.655 0 0 0-.642-.667.655.655 0 0 0-.642.667c0 .368.287.667.642.667Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64748B",
    fillRule: "evenodd",
    d: "M15.948 13.333a.147.147 0 0 1 .147.186c-.133.474-.346.88-.686 1.22-.5.5-1.132.72-1.914.826-.76.102-1.73.102-2.955.102H9.132c-1.225 0-2.196 0-2.955-.102-.782-.106-1.414-.327-1.914-.826-.498-.499-.72-1.132-.825-1.913-.102-.76-.102-1.73-.102-2.955v-.075c0-1.225 0-2.196.102-2.956.105-.781.327-1.414.825-1.913.5-.499 1.132-.72 1.914-.826C6.937 4 7.907 4 9.132 4h1.408c1.225 0 2.196 0 2.955.102.782.105 1.414.327 1.914.825.34.342.553.746.686 1.221a.147.147 0 0 1-.147.185h-1.683c-1.891 0-3.558 1.494-3.558 3.5 0 2.007 1.667 3.5 3.558 3.5h1.683Zm-9.279-1a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v4a.5.5 0 0 1-.5.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.ee95c0d3eb32390df65eb2c96c054413.svg";
export { ForwardRef as ReactComponent };